export default {
    hosts(){
        if (window.location.host.indexOf('uniondrug.cn') > -1) {
            return {
                NODE_ENV : 'production',
                VUE_APP_TITLE : 'production',
                VUE_APP_APPID : 'wx1b395628daf7b34c',
                VUE_PAY_AUTH : 'https://card.wecity.qq.com',
                VUE_APP_URL : 'https://jwt-backend.uniondrug.cn',
                VUE_SHARE_FRONTEND_URL : 'https://share-frontend.uniondrug.cn',
                VUE_APP_device : '//gather.uniondrug.cn',
                VUE_APP_URL11 : 'https://activity-more-backend.uniondrug.cn',
                VUE_APP_NEWS : 'https://activity-news-backend.uniondrug.cn',
                VUE_APP_WX : 'https://wx.uniondrug.cn',
                VUE_APP_AUTHHOST : 'https://auth-backend.uniondrug.cn',
                VUE_APP_DOMAIN : '.uniondrug.cn',
                VUE_APP_SHOP : 'https://wx.uniondrug.cn/v2/fesco',
                VUE_APP_WXAPI : 'https://wxapi.uniondrug.cn',
                VUE_APP_QYAPPID : 'ww46d8e3a14d195f55',
                doctor_APPID : 'wx6eaa8123bea26e0a',
                patient_APPID : 'wxca4f0aa549c6f720',
                claims_APPID : 'wx30d5279c00bc1403',
                zhiying_APPID:'wx74f1c4ed31eef5fa',
                xadoctor_APPID:'wxd7c1fe3e37a8a990',
                xapatient_APPID:'wx3e909bfcc08633ae',
                zypatient_APPID:'wxa25d1d0674e245dc',// 耀佳健康服务
                zydoctor_APPID:'wx5c5d1b4510a63e0c',// 智予铭医
                zyagent_APPID:'wx186f0535e4583ffe',// 智予医助
                xfagent_APPID:'wx0a950e3146972eb6',// 商保服务助手小福
                rxpatient_APPID:'wx9aa3fc6cf8d21952',// 乳腺健康患者援助中心
                rxdoctor_APPID:'wx1387ec2f7b4172f1',// 乳腺健康患者援助中心
                tqpatient_APPID:'wxe42aa0013a11cb57',// 心安
                tqdoctor_APPID:'wx2910d926d47541b4',// 铁樵商保铭医
                xinan_APPID:'wx3e909bfcc08633ae',
                VALID_CALLBACK_DOMAIN:['uniondrug.cn','m.tk.cn'],//第三方回调地址
                sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=production',
            }
        } else if (window.location.host.indexOf('uniondrug.net') > -1) {
            return {
                NODE_ENV : 'production',
                VUE_APP_TITLE : 'release',
                VUE_APP_APPID : 'wx764762c2fd709241',
                VUE_APP_URL : 'https://jwt-backend.uniondrug.net',
                VUE_APP_device : '//gather.uniondrug.net',
                VUE_APP_URL11 : 'https://activity-more-backend.uniondrug.net',
                VUE_APP_NEWS : 'https://activity-news-backend.uniondrug.net',
                VUE_APP_WX : 'https://wx.uniondrug.net',
                VUE_APP_AUTHHOST : 'https://auth-backend.uniondrug.net',
                VUE_APP_DOMAIN : '.uniondrug.net',
                VUE_APP_SHOP : 'https://wx.uniondrug.net/v2/fesco',
                VUE_APP_WXAPI : 'https://wxapi.uniondrug.net',
                VUE_APP_QYAPPID : 'ww46d8e3a14d195f55',
                doctor_APPID : 'wx9f85d8bdb47ec705',
                patient_APPID : 'wxfc198cf31a0a2885',
                claims_APPID : 'wxfc198cf31a0a2885',
                zhiying_APPID:'wx74f1c4ed31eef5fa',
                xadoctor_APPID:'wx9f85d8bdb47ec705',
                xapatient_APPID:'wx3209d6252d1b9197',
                zypatient_APPID:'wx3209d6252d1b9197',// 耀佳
                zydoctor_APPID:'wx9f85d8bdb47ec705',// 智予医生
                zyagent_APPID:'wx3209d6252d1b9197',// 智予经纪人
                xfagent_APPID:'wx3209d6252d1b9197',// 商保服务助手小福
                rxpatient_APPID:'wxfc198cf31a0a2885',// 乳腺健康患者援助中心
                rxdoctor_APPID:'wx7f20c942bd8bc51a',// 乳腺健康患者援助中心
                tqpatient_APPID:'wxfc198cf31a0a2885',// 铁樵患者援助中心
                tqdoctor_APPID:'wx7f20c942bd8bc51a',// 铁樵铁樵商保铭医
                VALID_CALLBACK_DOMAIN:['uniondrug.net','ecuat.tk.cn'],//第三方回调地址
                sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=default',
            }
        } else{
            return {
                NODE_ENV : 'production',
                VUE_APP_TITLE : 'test',
                VUE_APP_APPID : 'wx7e9998ef924c86fb',
                VUE_PAY_AUTH : 'https://mitest.wecity.qq.com',
                VUE_APP_URL : 'https://jwt-backend.turboradio.cn',
                VUE_SHARE_FRONTEND_URL : 'https://share-frontend.turboradio.cn',
                VUE_APP_device : '//gather.turboradio.cn',
                VUE_APP_URL11 : 'https://activity-more-backend.turboradio.cn',
                VUE_APP_NEWS : 'https://activity-news-backend.turboradio.cn',
                VUE_APP_WX : 'https://wx.turboradio.cn',
                VUE_APP_AUTHHOST : 'https://auth-backend.turboradio.cn',
                VUE_APP_DOMAIN : '.turboradio.cn',
                VUE_APP_SHOP : 'https://wx.turboradio.cn/v2/fesco',
                VUE_APP_WXAPI : 'https://wxapi.turboradio.cn',
                VUE_APP_QYAPPID : 'ww46d8e3a14d195f55',
                doctor_APPID : 'wx7f20c942bd8bc51a',
                patient_APPID : 'wxfc198cf31a0a2885',
                claims_APPID : 'wxfc198cf31a0a2885',
                zhiying_APPID:'wx74f1c4ed31eef5fa',
                xadoctor_APPID:'wx9f85d8bdb47ec705',
                xatestpatient_APPID:'wx3209d6252d1b9197',
                xinan_APPID:'wx3e909bfcc08633ae',
                xapatient_APPID:'wx3209d6252d1b9197',
                zypatient_APPID:'wx3209d6252d1b9197',// 耀佳
                zydoctor_APPID:'wx9f85d8bdb47ec705',// 智予医生
                zyagent_APPID:'wxfc198cf31a0a2885',// 智予经纪人
                xfagent_APPID:'wxfc198cf31a0a2885',// 商保服务助手小福
                rxpatient_APPID:'wxfc198cf31a0a2885',// 乳腺健康患者援助中心
                rxdoctor_APPID:'wx7f20c942bd8bc51a',// 乳腺健康患者援助中心
                tqpatient_APPID:'wxfc198cf31a0a2885',// 铁樵患者援助中心
                tqdoctor_APPID:'wx7f20c942bd8bc51a',// 铁樵铁樵商保铭医
                VALID_CALLBACK_DOMAIN:['turboradio.cn','localhost','ecuat.tk.cn'],//第三方回调地址
                sensor_track_server:'https://ssd-etc.uniondrug.cn/sa?project=default',
            }
        }
    }
}
